<template>
  <div class="wrap">
    <div class="title">蔵衛門IDでログイン</div>
    <div class="row">
      <ValidationInput field-name="メールアドレス"
                       :valid-rules="mailRules"
                       ref="mailInput">
        <input type="email"
               placeholder="メールアドレス"
               v-model="mail" />
      </ValidationInput>
    </div>
    <div class="row">
      <ValidationInput field-name="パスワード"
                       :valid-rules="passwordRules"
                       ref="passwordInput">
        <input type="password"
               placeholder="パスワード"
               v-model="password" />
      </ValidationInput>
    </div>
    <div v-if="loginError" class="login-err-msg">
      ログインに失敗しました<br/>
      メールアドレス、または、パスワードを確認してください
    </div>
    <div class="btn-wrap">
      <button class="btn login-btn"
              @click="tryLogin"
              :disabled="!isValid()">
        ログイン
      </button>
    </div>
    <div class="btn-wrap">
      <button class="btn registration-btn"
              @click="$router.push('new-registration')">
        蔵衛門ID新規登録(無料)
      </button>
    </div>
    <div class="row link-row">
      <router-link to="/request-password-reset">パスワードを忘れた場合</router-link>
    </div>
    <!-- 初回リリース時非表示 -->
    <div v-if="false" class="row link-row">
      <a href="#">蔵衛門IDについて</a>
    </div>
  </div>
</template>

<script>
import ValidationInput from '@/components/ui/ValidationInput.vue'

export default {
  name: 'Login',
  components: {
    ValidationInput
  },
  data() {
    return {
      mail: '',
      password: '',
      loginError: false,
      mailRules: { required: true },
      passwordRules: { required: true }
    }
  },
  methods: {
    tryLogin() {
      this.loginError = false;

      const redirectUrl = this.$route.query.redirect || '/';
      const args = {
        mail: this.mail,
        password: this.password,
        __apiOptions: { noErrorDialog: true },
      }

      this.$store.dispatch('api/loginKuraemonId', args).then((loginResult) => {
        if ( this.$store.getters['api/apiError'] ) {
          this.loginError = true;
          return;
        }
        console.log(loginResult);
        this.$router.replace({ path: redirectUrl });
      })
    },
    isValid() {
      if (!this.$refs.mailInput || !this.$refs.passwordInput) return false;
      return this.$refs.mailInput.$children[0].flags.valid && this.$refs.passwordInput.$children[0].flags.valid;
    }
  }
}
</script>

<style scoped>
  .wrap {
    text-align: center;
    padding: 4rem;
  }
  .title {
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 2rem;
    text-align: center;
  }
  .row {
    margin: 1rem 0;
  }
  input {
    border: solid 1px #333;
    border-radius: 0.5rem;
    padding: 0.75rem 0.5rem;
    width: 30rem;
  }
  .btn-wrap {
    margin: 1rem 0;
  }
  .btn {
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.5rem;
    width: 17rem;
  }
  .login-btn {
    background-color: #333;
    color: white;
    margin-top: 2rem;
  }
  .login-btn:disabled {
    background-color: #999;
    color: #ccc;
  }
  .registration-btn {
    background-color: white;
    border: solid 1px #333;
    color: #333;
    margin-bottom: 1rem;
  }
  .link-row {
    text-align: center;
  }
  .login-err-msg {
    color: crimson;
    font-size: 0.9rem;
    margin: 1rem auto;
    padding: 1rem;
    text-align: left;
    width: 30rem;
  }
@media (max-width: 1024px) {
  input {
    max-width: 420px;
    width: 100%;
  }
  .login-err-msg {
    max-width: 420px;
    width: 100%;
  }
}
</style>